export default "__VITE_ASSET__7SPYEJ$o__"